import { Link } from "react-router-dom";
import { Radar } from "lucide-react";

export function EmptyState({ title = "Stiamo raccogliendo nuove opportunità. Dicci cosa stai cercando", text, testid = "opportunities-empty-state" }) {
  return (
    <div data-testid={testid} className="chrome panel relative overflow-hidden rounded-3xl px-6 py-14 text-center sm:px-12">
      <div className="pointer-events-none absolute -left-20 -top-20 h-60 w-60 glow-red" />
      <div className="pointer-events-none absolute -bottom-20 -right-20 h-60 w-60 glow-blue" />
      <div className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-[var(--nero)]">
        <Radar className="text-[var(--blu)]" aria-hidden="true" />
      </div>
      <h3 className="relative mx-auto mt-6 max-w-xl text-xl font-semibold text-white sm:text-2xl">{title}</h3>
      <p className="relative mx-auto mt-3 max-w-lg text-sm muted">{text || "Le opportunità vengono pubblicate solo dopo la verifica con i partner proponenti. Nel frattempo puoi segnalarci la tua ricerca."}</p>
      <div className="relative mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/segnala-cosa-cerchi" className="btn btn-red" data-testid={`${testid}-cta`}>Segnala cosa cerchi</Link>
      </div>
    </div>
  );
}
